var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { SearchableMenuBody } from './SearchableMenuBody';
import { SearchableMenuPopover } from './SearchableMenuPopover';
import { SearchableMenuProvider } from './SearchableMenuProvider';
import { SearchableMenuSearchHeader } from './SearchableMenuSearchHeader';
import { useGroupItems } from './useGroupItems';
import { useSearchableMenuFuse } from './useSearchableMenuFuse';
/**
 * A flexible, searchable dropdown menu component that uses Fuse.js for fast in-memory fuzzy searching.
 */
export function SearchableMenu(props) {
    const { renderTarget, items, itemGroupKey, groups, keys, placeholder, children, initiallyOpen = false, onClose, fuseOptions, useTargetWidth, open, } = props;
    const _a = useSearchableMenuFuse(items, Object.assign({ keys }, fuseOptions)), { items: searchedItems } = _a, search = __rest(_a, ["items"]);
    const nodes = useGroupItems({
        groups: groups || [],
        items: searchedItems,
        groupKey: itemGroupKey,
    });
    return (<SearchableMenuProvider initiallyOpen={initiallyOpen} onClose={onClose} items={nodes} {...search}>
      <SearchableMenuPopover renderTarget={renderTarget} useTargetWidth={useTargetWidth} open={open}>
        <SearchableMenuSearchHeader placeholder={placeholder}/>
        <SearchableMenuBody>{children}</SearchableMenuBody>
      </SearchableMenuPopover>
    </SearchableMenuProvider>);
}
